module.exports = __webpack_public_path__ + "img/logo.f725f603.png";